import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WorkflowLog {
  timestamp: string;
  level: 'INFO' | 'WARNING' | 'ERROR';
  step: string;
  message: string;
}

@Component({
  selector: 'app-workflow-logs-dialog',
  templateUrl: './workflow-logs-dialog.component.html',
  styleUrls: ['./workflow-logs-dialog.component.scss'],
})
export class WorkflowLogsDialogComponent {
  workflowName: string;

  logs: WorkflowLog[] = [
    {
      timestamp: '2026-05-07 08:00:01 AM',
      level: 'INFO',
      step: 'Trigger',
      message: 'Workflow triggered by event: patient_status_change',
    },
    {
      timestamp: '2026-05-07 08:00:02 AM',
      level: 'INFO',
      step: 'Condition (If)',
      message: 'Evaluating condition: patient_status = "Active"',
    },
    {
      timestamp: '2026-05-07 08:00:02 AM',
      level: 'INFO',
      step: 'Condition (If)',
      message: 'Condition matched — branching YES path',
    },
    {
      timestamp: '2026-05-07 08:00:03 AM',
      level: 'INFO',
      step: 'Email Alert',
      message: 'Sending email to patient@example.com',
    },
    {
      timestamp: '2026-05-07 08:00:04 AM',
      level: 'WARNING',
      step: 'Email Alert',
      message: 'SMTP response delayed — retrying (1/3)',
    },
    {
      timestamp: '2026-05-07 08:00:06 AM',
      level: 'INFO',
      step: 'Email Alert',
      message: 'Email delivered successfully',
    },
    {
      timestamp: '2026-05-07 08:00:06 AM',
      level: 'ERROR',
      step: 'Update Record',
      message: 'Failed to update record: timeout after 2000ms',
    },
    {
      timestamp: '2026-05-07 08:00:07 AM',
      level: 'INFO',
      step: 'System',
      message: 'Workflow execution completed with 1 error',
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<WorkflowLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { workflowName: string }
  ) {
    this.workflowName = data?.workflowName || 'Workflow';
  }

  close(): void {
    this.dialogRef.close();
  }
}
